import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsOfUse = () => {
  return (
    <>
      <SEO 
        title="Terms of Use - IT World"
        description="Read the terms and conditions for using IT World website and services."
      />
      <div className="bg-primary text-white py-5">
        <Container>
          <h1 className="text-center mb-3">Terms of Use</h1>
          <p className="text-center lead">Last Updated: February 2025</p>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0 shadow-sm">
          <Card.Body className="p-4 p-md-5">
            <section className="mb-5">
              <h2 className="h4 mb-3">1. Acceptance of Terms</h2>
              <p>
                Welcome to IT World (operated through www.accountssuitpro.com). By accessing or using 
                our website and services, you agree to be bound by these Terms of Use. If you do 
                not agree to these terms, please do not use our services.
              </p>
              <p>
                These terms apply to all visitors, users, and customers of our website and services.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">2. Description of Services</h2>
              <p>IT World provides the following services:</p>
              <ul>
                <li>Sale of genuine software license keys</li>
                <li>Custom software development services</li>
                <li>Web and mobile application development</li>
                <li>IT consulting and support services</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">3. User Accounts</h2>
              <h5>3.1 Account Registration</h5>
              <p>
                To make purchases, you may need to create an account. You agree to provide accurate, 
                current, and complete information during registration and to update such information 
                to keep it accurate.
              </p>
              
              <h5 className="mt-4">3.2 Account Security</h5>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials. 
                You agree to notify us immediately of any unauthorized use of your account.
              </p>
              
              <h5 className="mt-4">3.3 Account Termination</h5>
              <p>
                We reserve the right to suspend or terminate your account if you violate these terms 
                or engage in fraudulent or illegal activities.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">4. Products and Purchases</h2>
              <h5>4.1 Software License Keys</h5>
              <p>
                All software license keys sold on our platform are genuine and sourced from authorized 
                distributors. Each license key is subject to the terms and conditions of the respective 
                software publisher.
              </p>
              
              <h5 className="mt-4">4.2 Pricing</h5>
              <p>
                All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes. 
                We reserve the right to change prices at any time without prior notice.
              </p>
              
              <h5 className="mt-4">4.3 Payment</h5>
              <p>
                We accept payments through Razorpay, which includes UPI, credit/debit cards, net 
                banking, and digital wallets. All transactions are processed securely.
              </p>
              
              <h5 className="mt-4">4.4 Delivery</h5>
              <p>
                Software license keys are delivered digitally via email and/or through your account 
                dashboard immediately after successful payment. Delivery times may vary based on 
                the product.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">5. User Responsibilities</h2>
              <p>By using our services, you agree NOT to:</p>
              <ul>
                <li>Use our services for any illegal or unauthorized purpose</li>
                <li>Resell or redistribute license keys purchased from us</li>
                <li>Share your account with others or allow unauthorized access</li>
                <li>Attempt to hack, disrupt, or damage our website or services</li>
                <li>Use automated systems to access our website without permission</li>
                <li>Provide false or misleading information</li>
                <li>Infringe upon intellectual property rights of others</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">6. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos, images, and software, 
                is the property of IT World or its licensors and is protected by copyright and 
                trademark laws.
              </p>
              <p>
                Software license keys sold through our platform are subject to the intellectual 
                property rights and license agreements of their respective publishers.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">7. Limitation of Liability</h2>
              <p>
                IT World shall not be liable for any indirect, incidental, special, consequential, 
                or punitive damages arising from your use of our services. Our total liability 
                shall not exceed the amount paid by you for the specific product or service in question.
              </p>
              <p>
                We are not responsible for any issues arising from the use of software products 
                after activation, as these are governed by the respective software publishers' terms.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">8. Disclaimer of Warranties</h2>
              <p>
                Our services are provided "as is" without warranties of any kind, either express 
                or implied. We do not warrant that our services will be uninterrupted, error-free, 
                or completely secure.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">9. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are not responsible for 
                the content or practices of these websites. Your use of third-party sites is at 
                your own risk.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">10. Refund and Cancellation</h2>
              <p>
                Refunds and cancellations are subject to our <Link to="/refund-policy">Cancellation & Refund Policy</Link>. 
                Please review this policy before making a purchase.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">11. Privacy</h2>
              <p>
                Your use of our services is also governed by our <Link to="/privacy-policy">Privacy Policy</Link>, 
                which describes how we collect, use, and protect your personal information.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">12. Governing Law</h2>
              <p>
                These Terms of Use shall be governed by and construed in accordance with the laws 
                of India. Any disputes arising from these terms shall be subject to the exclusive 
                jurisdiction of the courts in India.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">13. Changes to Terms</h2>
              <p>
                IT World reserves the right to modify these Terms of Use at any time. Changes will 
                be effective immediately upon posting on this page. Your continued use of our 
                services after any changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">14. Contact Information</h2>
              <p>If you have any questions about these Terms of Use, please contact us:</p>
              <ul className="list-unstyled">
                <li><strong>Email:</strong> <a href="mailto:itworldwani@gmail.com">itworldwani@gmail.com</a></li>
                <li><strong>Phone:</strong> +91 9561306384</li>
                <li><strong>Website:</strong> www.accountssuitpro.com</li>
              </ul>
            </section>

            <hr className="my-5" />

            <div className="text-center">
              <p className="text-muted mb-3">
                By using IT World services, you acknowledge that you have read, understood, 
                and agree to these Terms of Use.
              </p>
              <Link to="/contact" className="btn btn-primary me-2">
                Contact Us
              </Link>
              <Link to="/privacy-policy" className="btn btn-outline-primary">
                Privacy Policy
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default TermsOfUse;
